module.exports = __webpack_public_path__ + "static/img/La-Beaujoire-Stadium.ef0da12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/La-Beaujoire-Stadium.jpg
// module id = No/n
// module chunks = 0